export default "__VITE_ASSET__TROTFvz1__"